import {
  getPreviewRecipientKey,
  isRegisteredPreviewSend,
  type DecisionEngineDestinationDefinition,
} from "./definition";
import { hightouchMappingWithTags } from "./sync-config-helpers";

export const cordialDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "cordial",
  category: "trigger",
  generateSyncConfig: ({
    channelConfig,
    isPreview,
    sendToHightouchUser,
    previewRecipientMode,
    messageTags,
  }) => {
    const registeredPreview = isRegisteredPreviewSend({
      isPreview,
      previewRecipientMode,
    });
    const previewRecipientKey = getPreviewRecipientKey(channelConfig);
    return {
      type: "trigger",
      templateKey: { type: "standard", from: "campaign_id" },
      mappings: [hightouchMappingWithTags(messageTags)],
      // Registered mode without a key falls back to email keying even on cID
      // channels: the registered recipient is the account address, so
      // external_id would otherwise be sent as a nonexistent cID.
      externalIdMapping:
        registeredPreview && previewRecipientKey
          ? {
              type: "static",
              to: "cID",
              value: previewRecipientKey,
              valueType: "STRING",
            }
          : registeredPreview
            ? { from: "external_id", to: "email" }
            : {
                from: "external_id",
                to:
                  channelConfig.recipientType === "cID" &&
                  !(isPreview && sendToHightouchUser)
                    ? "cID"
                    : "email",
              },
    };
  },
  // The Cordial trigger sync reads both keys at runtime (defaults 500 / 5);
  // the rETL config sets no cap, so these bounds just keep overrides sane.
  syncTuning: {
    batchSize: { configKey: "rowsPerBatch", max: 1000 },
    parallelization: { max: 100 },
  },
};
